export default __webpack_public_path__ + "static/media/loading_white.4af06923.svg";